<app-spash-screen></app-spash-screen>
<router-outlet></router-outlet>
<notifier-container></notifier-container>